import { SegmentEvent } from '@/integrations/segment/SegmentEvent';
import { StandardTriageRecommendationPageEventTracking } from '@/modules/auth/models/segmentevents/StandardTriageRecommendationPageEventTracking';
import { SegmentPropertyValue } from '@/integrations/segment/enums/SegmentPropertyValue';

export class StandardTriageRecommendationPageSelectedEventTracking extends StandardTriageRecommendationPageEventTracking {
  static eventName: SegmentEvent = SegmentEvent.STANDARD_TRIAGE_RECOMMENDATION_PAGE_SELECTED;
  selected_product: SegmentPropertyValue;

  constructor(
    eventProperties: Partial<StandardTriageRecommendationPageSelectedEventTracking> = {}
  ) {
    super(eventProperties);
    this.selected_product = SegmentPropertyValue.ONLINE_WILL;
  }
}
